import React from 'react'

function ArrowLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#E0E0E0"
        fillRule="evenodd"
        d="M2.239 12.5c0-.431.35-.781.781-.781h18.75a.781.781 0 110 1.562H3.02a.781.781 0 01-.781-.781z"
        clipRule="evenodd"
      />
      <path
        fill="#E0E0E0"
        fillRule="evenodd"
        d="M9.823 5.698c.305.305.305.8 0 1.104L4.125 12.5l5.698 5.698a.781.781 0 11-1.105 1.104l-6.25-6.25a.781.781 0 010-1.104l6.25-6.25a.781.781 0 011.105 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default ArrowLeft
